import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faEye } from "@fortawesome/free-solid-svg-icons";

import Input from "../../Components/Input";
import useFetch from "../../Hooks/useFetch";
import ActionNotifications from "../../Components/ActionNotifications";
import { apiBaseURL } from "../../Utils/ProjectConstants";
import atlasLogo from "../../Assets/images/AtlasLogo-white.png";
import "./styles.css";

export default function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const fetch = useFetch(navigate);
  const [notifyResponse, setResponse] = useState({});

  const [state, setState] = useState({
    password: "",
    confirmPassword: "",
    passwordError: false,
    confirmPasswordError: false,
    showPassword1: false,
    showPassword2: false,
    showSpinner: false,
    notifications: [],
  });

  const fetchSuccessful = (response) => {
    setResponse(response);
    return (
      response?.success &&
      response?.data?.statusCode &&
      response?.success !== "Invalid Model"
    );
  };
  const email = location.state?.email;
  const securityCode = location.state?.securityCode;
  // console.log("email => ", email, securityCode);

  if (!email || !securityCode) {
    navigate("/login/reset");
    return null; // prevents rendering the page and avoids API calls
  }
  const isValidPassword = (password) => {
    const minLength = password.length >= 6;
    const hasDigit = /\d/.test(password);
    const hasSpecialChar = /[^a-zA-Z0-9]/.test(password);
    const hasUpperCaseChar = /[A-Z]/.test(password);
    const hasLowerCaseChar = /[a-z]/.test(password);
    const areAllDigitsSame = !/^(\d)\1+$/.test(password);

    return (
      minLength &&
      hasDigit &&
      hasSpecialChar &&
      hasUpperCaseChar &&
      hasLowerCaseChar &&
      areAllDigitsSame
    );
  };

  const onSubmit = async () => {
    let stateValues = {
      ...state,
      notifications: [],
      passwordError: false,
      confirmPasswordError: false,
    };

    if (stateValues.password === "") {
      stateValues = { ...stateValues, passwordError: true };
      stateValues.notifications.push({
        isMessageInGDStanding: false,
        message: "Password is required.",
      });
    }

    if (stateValues.confirmPassword === "") {
      stateValues = { ...stateValues, confirmPasswordError: true };
      stateValues.notifications.push({
        isMessageInGDStanding: false,
        message: "Confirm password field is required.",
      });
    }

    if (
      stateValues.password &&
      stateValues.confirmPassword &&
      stateValues.password !== stateValues.confirmPassword
    ) {
      stateValues.confirmPasswordError = true;
      stateValues.notifications.push({
        isMessageInGDStanding: false,
        message: "Password and confirm password fields do not match.",
      });
    }
    if (stateValues.confirmPasswordError || stateValues.passwordError) {
      stateValues.notifications.push({
        isMessageInGDStanding: false,
        message: "Please fix all error(s) before submitting.",
      });
    }
    if (stateValues.notifications.length > 0) {
      setState(stateValues);
      return;
    }
    setState(stateValues);
    if (
      !stateValues.confirmPasswordError &&
      !stateValues.passwordError &&
      isValidPassword(stateValues.password)
    ) {
      //send api call
      setState({ ...stateValues, showSpinner: true });
      const body = {
        email: email,
        password: state.password,
        securitycode: parseInt(securityCode),
      };
      const response = await fetch.post(
        `${apiBaseURL}/api/Account/ForgotPassword`,
        body
      );
      stateValues.notifications.push({
        isMessageInGDStanding: true,
        message: "Passsword reset Successful",
      });
      //redirect to login
      navigate("/login");
    } else {
      console.log("not alphanumeric ");
      if (state.password.length <= 6) {
        stateValues.notifications.push({
          isMessageInGDStanding: false,
          message: "Passwords must be at least 6 characters.",
        });
      }

      if (!/[^a-zA-Z0-9]/.test(state.password)) {
        stateValues.notifications.push({
          isMessageInGDStanding: false,
          message:
            "Passwords must have at least one non alphanumeric character.",
        });
      }

      if (!/[A-Z]/.test(state.password)) {
        stateValues.notifications.push({
          isMessageInGDStanding: false,
          message: "Passwords must have at least one uppercase ('A'-'Z').",
        });
      }
      if (!/[a-z]/.test(state.password)) {
        stateValues.notifications.push({
          isMessageInGDStanding: false,
          message: "Passwords must have at least one lowercase ('a'-'z').",
        });
      }
      if (!/\d/.test(state.password)) {
        stateValues.notifications.push({
          isMessageInGDStanding: false,
          message: "Passwords must have at least one digit ('0'-'9').",
        });
      }

      if (/^(\d)\1+$/.test(state.password)) {
        stateValues.notifications.push({
          isMessageInGDStanding: false,
          message: "Passwords must use at least 1 different characters.",
        });
      }
      setState(stateValues);
    }
  };
  const showPassword1 = () => {
    !state.showPassword1
      ? setState({ ...state, showPassword1: true })
      : setState({ ...state, showPassword1: false });
  };
  const showPassword2 = () => {
    !state.showPassword2
      ? setState({ ...state, showPassword2: true })
      : setState({ ...state, showPassword2: false });
  };
  const renderGrid = () => {
    return (
      <div className="renderFadeIn row g-0">
        <h4 className="mb-4 message">
          Create a new password that is at least 6 characters long, contains at
          least one non alphanumeric character, and contains at least one digit
          ('0'-'9').
        </h4>
        <div>
          <Input
            isError={state.passwordError}
            name="password"
            onChange={(e) => setState({ ...state, password: e.target.value })}
            value={state.password}
            labelTitle="New Password"
            type={state.showPassword1 ? "text" : "password"}
          />
          <i className="one" onClick={() => showPassword1()}>
            <FontAwesomeIcon icon={faEye} size="md" className="gray icon" />
          </i>
        </div>
        <form onSubmit={onSubmit}>
          <div>
            <Input
              isError={state.confirmPasswordError}
              name="confirmPassword"
              onChange={(e) =>
                setState({ ...state, confirmPassword: e.target.value })
              }
              value={state.confirmPassword}
              labelTitle="Confirm Password"
              type={state.showPassword2 ? "text" : "password"}
            />
            <i className="two" onClick={() => showPassword2()}>
              <FontAwesomeIcon icon={faEye} size="md" className="gray icon" />
            </i>
          </div>
          <button type="submit" className="col-12 button yellowBG mb-3">
            {state.showSpinner ? (
              <FontAwesomeIcon icon={faSpinner} className="fa-spin" size="lg" />
            ) : (
              "Change Password"
            )}
          </button>
        </form>
        <h5 className="noBold darkGray return">
          Return to{" "}
          <Link className="linkText yellow" to="/login">
            Login
          </Link>
        </h5>
      </div>
    );
  };

  return (
    <div id="LoginPage" className="inner ">
      <div id="ResetPassword" className="mt-5 resetpage p-md-5 p-lg-3 col-12">
        <ActionNotifications arrayOfToasts={state.notifications} />
        <div className="reset-container text-center mt-5 col-lg-4 col-12 me-5 p-4">
          <div className="row mb-3">
            <div className="col-12">
              <img alt="Atlas Logo" src={atlasLogo} width="125" />
            </div>
          </div>
          <div className="row g-0">{renderGrid()}</div>
        </div>
      </div>
    </div>
  );
}
